/** What each plan includes, in the words the plan cards use. */

export const FREE_LIMIT = 25;

export function freePlanPoints(limit: number = FREE_LIMIT): string[] {
  return [
    `Your ${limit} most recent recordings stay playable`,
    'Share links, comments and reactions',
    'The Mac recorder and the browser recorder',
  ];
}

export const TEAM_PLAN_POINTS = [
  'Unlimited recordings, nothing locks',
  'Captions and searchable transcripts',
  'Cut, trim and correct your recordings',
  'One shared library the whole team records into',
  'Admins who can see and manage every recording',
];
